var _defs, _circle, _circle2, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQNav5Selected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1-q-nav-5-selected{fill:#fff;}.cls-2-q-nav-5-selected{fill:#33b0ce;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Medications-PB-02") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1-q-nav-5-selected",
    cx: 17,
    cy: 17,
    r: 17
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2-q-nav-5-selected",
    cx: 17,
    cy: 17,
    r: 15.59
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-q-nav-5-selected",
    d: "M21.55,15.69a5.15,5.15,0,1,0,5.15,5.15A5.16,5.16,0,0,0,21.55,15.69Zm0,1.3a3.8,3.8,0,0,1,2,.58l-5.27,5.28A3.83,3.83,0,0,1,21.55,17Zm0,7.7a3.78,3.78,0,0,1-2.41-.87l5.39-5.39a3.83,3.83,0,0,1-3,6.26Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-q-nav-5-selected",
    d: "M17,17.55h0l3.45-4A3.57,3.57,0,1,0,15.08,8.9l-6.9,7.94a3.52,3.52,0,0,0-.87,2.59,3.56,3.56,0,0,0,3.56,3.32h.25a3.54,3.54,0,0,0,2.45-1.22l3.45-4Zm-1-7.8A2.24,2.24,0,0,1,17.62,9h.16a2.27,2.27,0,0,1,1.71,3.76l-3,3.49-3.45-3ZM13.61,19.5a.13.13,0,0,0-.09,0l-4.79.43a2.34,2.34,0,0,1-.1-1.05l5.88-.41Zm-1.45-5.26,1,.83-1.8.12Zm-2,2.34,4.41-.31,1,.84-.09,0-6.1.43ZM11,21.45a2.21,2.21,0,0,1-1.31-.32l2.63-.23A2.27,2.27,0,0,1,11,21.45Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQNav5Selected);
export default __webpack_public_path__ + "static/media/q_nav_5_selected.4a04bf2a.svg";
export { ForwardRef as ReactComponent };